import Wrapper from 'components/Wrapper';
import Text from 'components/Text';
import { ReactSVG } from 'react-svg';
import { back_icon } from 'asset/icons';
import { fontSizes } from 'appconstants';
import ViewCustomerFunctional from './index.function'
import { useLocation } from 'react-router-dom';

const ViewCustomer = () => {
    const { navigate } = ViewCustomerFunctional()
    const { state } = useLocation()

    const DataRow = ({ label, value = '', isImage = false }) => (
        <div className="flex justify-between items-center py-3 border-b last:border-0 border-gray-100">
            <Text text={label} className='font-medium' size={fontSizes.h14} />

            {isImage ? (
                state?.logo ? (
                    <img
                        src={`${process.env.REACT_APP_IMAGE_URL}${state?.logo}`}
                        alt="Customer Logo"
                        className="h-10 w-10 rounded-md object-contain border border-gray-100"
                    />
                ) : (
                    <Text text="No Logo" className="text-gray-400 italic" size={fontSizes.h14} />
                )
            ) : (
                <Text text={value} className="font-medium text-gray-500" size={fontSizes.h14} />
            )}
        </div>
    );

    return (
        <Wrapper className='flex flex-col h-screen bg-gray-50/30 p-6'>
            {/* Header */}
            <div className='flex items-center gap-3 mb-6'>
                <div
                    onClick={() => navigate(-1)}
                    className='h-10 w-10 cursor-pointer rounded-md flex items-center justify-center bg-white border border-gray-200 hover:bg-gray-50 transition'
                >
                    <ReactSVG src={back_icon} />
                </div>
                <div>
                    <Text text={state?.customerName ?? "-"} className='font-bold text-gray-900' size={fontSizes.h26} />
                </div>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
                <div className='rounded-xl border border-gray-200 bg-white p-4 shadow-sm'>
                    <Text text="Customer Details" className="font-bold mb-4" size={fontSizes.h18} />
                    <div className="flex flex-col">
                        <DataRow label="Customer Name" value={state?.customerName ?? "-"} />
                        <DataRow label="Address" value={state?.address ?? "-"} />
                        <DataRow label="Customer Logo" isImage />
                        <DataRow label="Status" value={state?.isActive ? "Active" : "InActive"} />
                        <DataRow label="Rooms" value={state?.rooms?.length ?? 0} />
                        <DataRow label="Stores" value={state?.stores?.length ?? 0} />
                    </div>
                </div>

                <div className='rounded-xl border border-gray-200 bg-white p-4 shadow-sm'>
                    <Text text="Overview" className="font-bold mb-4" size={fontSizes.h18} />
                    <div className="flex flex-col">
                        <DataRow label="Active Audits" value="Yes" />
                        <DataRow label="Completed Audits" value="18" />
                        <DataRow label="Last Audit" value="12 Aug 2025" />
                    </div>
                </div>

            </div>
        </Wrapper>
    );
};

export default ViewCustomer;